import { requiredField } from './required';

/*********************************************************
 *                        CONSTANTS                      *
 ********************************************************/

const notValidDateErrorMessage = 'error.notValidDate';
const minAgeError = 'error.minAge';
const maxAgeError = 'error.maxAge';

/*********************************************************
 *                        HELPERS                        *
 ********************************************************/
function isValidFormat(input: string): boolean {
  const date_format_regex = /^\d{2}\/\d{2}\/\d{4}$/;
  return date_format_regex.test(input);
}

// Convertiamo la data (dd/mm/yyyy)
//e ci assicuriamo che sia valida
export const parseDateString = (dateString: string) => {
  const dateMembers: string[] = dateString.split('/');
  const date: Date = new Date(
    Number(dateMembers[2]), //YYYY
    Number(dateMembers[1]) - 1, //MM (In js i mesi sono 0 indexed)
    Number(dateMembers[0]), //DD
  );

  const isValidDate =
    isValidFormat(dateString) &&
    date &&
    date.getMonth() + 1 === Number(dateMembers[1]);
  return [date, isValidDate] as const;
};

/*********************************************************
 *                     ZOD VALIDATORS                    *
 ********************************************************/
export const dateValidator = requiredField.superRefine((dateString, ctx) => {
  const [, isValidDate] = parseDateString(dateString || '');
  if (!isValidDate) {
    ctx.addIssue({
      code: 'custom',
      message: notValidDateErrorMessage,
    });
  }
});

export const minMaxAgeValidator = dateValidator.superRefine(
  (dateString, ctx) => {
    const [inputDate, isValidDate] = parseDateString(dateString);
    const _18_years_ago_date_from_today = new Date(
      new Date().setFullYear(new Date().getFullYear() - 18),
    );
    const _100_years_ago_date_from_today = new Date(
      new Date().setFullYear(new Date().getFullYear() - 100),
    );

    if (!isValidDate)
      ctx.addIssue({
        code: 'custom',
        message: notValidDateErrorMessage,
      });
    if (inputDate > _18_years_ago_date_from_today)
      ctx.addIssue({
        code: 'custom',
        message: minAgeError,
      });
    else if (inputDate <= _100_years_ago_date_from_today)
      ctx.addIssue({
        code: 'custom',
        message: maxAgeError,
      });
  },
);

//controlliamo se la data inserita è di un documento già scaduto
//oppure se è oltre 11 anni da oggi
export const documentDateValidator = dateValidator.superRefine(
  (dateString, ctx) => {
    const [inputDate, isValidDate] = parseDateString(dateString);
    const today = new Date();
    const _11_years_from_today = new Date(
      new Date().setFullYear(new Date().getFullYear() + 11),
    );
    // ci assicuriamo che abbiano lo stesso orario così da comparare solo la data stessa
    today.setHours(12, 0, 0, 0);
    inputDate.setHours(12, 0, 0, 0);

    if (!isValidDate)
      ctx.addIssue({
        code: 'custom',
        message: notValidDateErrorMessage,
      });

    if (inputDate < today)
      ctx.addIssue({
        code: 'custom',
        message: 'error.isPastDate',
      });

    if (inputDate > _11_years_from_today)
      ctx.addIssue({
        code: 'custom',
        message: 'error.invalidExpirationDate',
      });
  },
);

/*********************************************************
 *                     FIELD FILTERS                     *
 ********************************************************/
//makes sure the date is complete 1/4/1996 --> 01/04/1996
export const validDateStringFilter = (dateString: unknown): boolean => {
  const regex = /^[0-9/]+$/; //  match only numbers and slashes
  return regex.test(dateString as string) || dateString === '';
};
